import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star, UserRound } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  const hasSamples = shortTestimonials.some(testimonial => testimonial.isSample);
  return <section className="py-12 bg-white border-y border-stone-200" data-id="element-274" data-mp="3nzv73wfw6dig">
      <div className="max-w-7xl mx-auto px-4" data-id="element-275" data-mp="3nxiix1jjj6wy">
        <div className="text-center mb-7" data-id="element-276" data-mp="5kt2v6hagjnh">
          <h2 className="text-blue-950 font-bold tracking-widest uppercase text-sm" data-id="element-277" data-mp="5jrgi5utoaqg">
            What Driving Instructors Are Saying
          </h2>
          {hasSamples && <p className="text-xs text-slate-500 mt-2" data-id="element-278" data-mp="figzk1ygg18a">
              Placeholder comments shown for layout — to be replaced with verified customer
              feedback.
            </p>}
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-279" data-mp="2hbojjop0j70i">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.text} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-stone-50 border border-stone-200 p-6 rounded-2xl shadow-sm shadow-blue-950/5 flex flex-col" data-id="element-280" data-mp="2ce4z271q1y04" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 mb-4" data-id="element-281" data-mp="v3gy3c3itq0n">
                <div className="flex gap-1 text-yellow-400" aria-label="5 out of 5 stars" data-id="element-282" data-mp="v5jm5ql4592q">
                  {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-283" data-mp="144ybgmpjndln" data-mpi={starIndex} />)}
                </div>
                {testimonial.isSample && <span className="text-[10px] font-bold uppercase tracking-wider text-blue-700 bg-blue-700/10 px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-284" data-mp="35v9sg6ped4ik">
                    Placeholder
                  </span>}
              </div>
              <p className="text-slate-800 italic mb-6 text-sm leading-relaxed" data-id="element-285" data-mp="i0nurakl9l8i">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-stone-200" data-id="element-286" data-mp="d34fq8g2h4fi">
                <div className="w-10 h-10 rounded-full bg-blue-950 flex items-center justify-center text-orange-500 shrink-0" aria-hidden="true" data-id="element-287" data-mp="qygcsmhp36zl">
                  <UserRound size={18} data-id="element-288" data-mp="10wmd4znus52c" />
                </div>
                <div className="min-w-0" data-id="element-289" data-mp="vyuivyzqk6uz">
                  <div className="font-bold text-blue-950 text-sm" data-id="element-290" data-mp="vxt5hnv8z8a3">{testimonial.role}</div>
                  <div className="flex items-center gap-1 text-xs text-slate-500" data-id="element-291" data-mp="19t54i7gfrkwt">
                    <MapPin size={11} className="text-orange-600 shrink-0" data-id="element-292" data-mp="15q8omoia62wk" />
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}